import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import Nav from "react-bootstrap/Nav";
import { useHistory, useLocation } from "react-router-dom";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import LoaderButton from "../components/LoaderButton";
import { useAppContext } from "../libs/contextLib";
import { useFormFields } from "../libs/hooksLib";
import { Auth, API } from "aws-amplify";
import libmime from "libmime";
import { onError } from "../libs/errorLib";
import AdminLeftMenu from "./AdminLeftMenu";
import MemberTypeItemNames from "./MemberTypeItemNames";
import AdminNewMail from "./AdminNewMail";
import AdminMailConfirm from "./AdminMailConfirm";
import AdminMailComplete from "./AdminMailComplete";
import config from '../config';
import "./Admin.css";
import "../admin.css";

export default function AdminHome() {
  console.log('AdminHome...');
  const search = useLocation().search;
  const qPage = new URLSearchParams(search).get('page'); // page
  console.log('qPage = ' + qPage);
  const [members, setMembers] = useState([]);
  const [refreshCounter, setRefreshCounter] = useState(0);
  const [pages, setPages] = useState([]);
  const [currentPage, setCurrentPage] = useState(qPage ? parseInt(qPage) : 1);
  const [listLength, setListLength] = useState(0);
  const [pageLimit, setPageLimit] = useState("50");

  const [memTypeGroup, setMemTypeGroup] = useState(0);

  const [renderingState, setRenderingState] = useState('Main');
  const [total, setTotal] = useState(0);

  const history = useHistory();

  const initializeChecks = (len) => {
    const n = (len < pageLimit) ? len : pageLimit;
    var arr = [];
    for (let i=0; i<n; i++) arr.push(0);
    console.log('checks arr:');
    console.log(arr);
    setChecks(arr);
    setSelectAll(0);
  };

  useEffect(() => {
    console.log('useEffect called...');
    console.log(isAdmin);
//    window.scrollTo(0, 0);

    const onLoad = async () => {
      try {
        console.log('onLoad called...');
        const credentials = await Auth.currentCredentials();
        console.log(credentials);
        if(!isAdmin) {
          history.push('/home');
        }
        const mc = await loadMembersOnCondition(false, fields.ascOrDesc); 
        console.log(mc);
        setTotal(mc);    
        const ms = await loadMembersOnCondition(true, fields.ascOrDesc); 
        console.log(ms);
        console.log('onLoad ms.length:' + ms.length);
        console.log('page count: ' + parseInt (ms.length / pageLimit));
        initializeChecks(ms.length);
        console.log('ascOrDesc=>' + fields.ascOrDesc);
        const n = parseInt (mc / pageLimit) + ( mc % pageLimit > 0 ? 1 : 0);
        console.log(n);
        let ps = [];
        console.log('currentPage: ' + currentPage);
        const maxp = 4 + parseInt(currentPage);
        console.log(`n=${n}, currentPage=${currentPage}, maxp=${maxp}`);
        var pnc = 0; //page num count
        var leftMost = false;
        var inTheMiddle = false;
        var rightMost = false;
        if (n > 9 && currentPage > 5) {
            ps.push({"label": '<<'});
        }
        for(let i=0; i < 9; i++) {
          if (currentPage <= 5) {
            if (!leftMost) {
              pnc = 0;
              leftMost = true;
            }
          } else if(currentPage > (n - 9) && !rightMost) {
            if (!rightMost) {
              pnc = currentPage - 9;
              rightMost = true;
            }
          } else {
            if (!inTheMiddle) {
               pnc = parseInt(currentPage) - 5;
              inTheMiddle = true;
            }
	  }
          pnc++;
          console.log('pnc: ' + pnc);
          if (pnc > n) continue;
          ps.push({"label": /*i+1*/pnc});
        }
        if (n > maxp && n > 8) {
          ps.push({"label": '>>'});
        }
        console.log('onLoad()........ps');
        console.log(ps);
        setPages(ps);
      } catch (e) {
        onError(e);
      }
    };
    onLoad();
  },[refreshCounter]);

  function setChecksOnPage(ms, limit, currPg) {
    const pl = parseInt (ms.length / limit) + ( ms.length % limit > 0 ? 1 : 0);
    let n = limit * currPg;
    console.log('#### n:' + n);
    n = ms.length < n ? parseInt(ms.length / limit) : limit; // page length
    console.log('#### pl:' + pl);
    console.log('#### currentPage:' + currPg);
    console.log('#### n:' + n);
    const a = [];
    for(let i=0; i < n; i++) a.push("0");
    console.log('#### n:' + JSON.stringify(a));
    console.log('## : call setCheck');
    setChecks(a);
  }

  async function loadMembersOnCondition(isLoad, ob) {
    console.log('loadMembersOnCondition...');
    let p = `ob=${ob}&rgs=0&cp=${currentPage}&pl=${pageLimit}`;
//    let p = `ob=${ob}`;
    let isMNumFilterd = false;
    if (fields.mNumBegin) {
      p += `&bn=${fields.mNumBegin}`;
      isMNumFilterd = true;
    }
    if (fields.mNumEnd) {
      p += `&en=${fields.mNumEnd}`;
        isMNumFilterd = true;
    }
    if (fields.mName)
      p += `&na=${fields.mName}`;
    if (fields.mAffiliationName)
      p += `&afn=${fields.mAffiliationName}`;

    if (fields.mPrefecture) {
      p += `&prf=${fields.mPrefecture}`;
      console.log('prefecture = ' + fields.mPrefecture);
    }

    if (!(0 == mStatus[0] && 0 == mStatus[1] && 0 == mStatus[2] && 0 == mStatus[3] && 0 == mStatus[4] && 0 == mStatus[5] && 0 == mStatus[6] && 0 == mStatus[7] && 0 == mStatus[8] && 0 == mStatus[9])) 
      p += `&mtp=${mStatus.join()}`;
    console.log(mStatus.join().split());

    const myUrl = isLoad ? '/members' : '/countMembers';
    const path = p.length > 0 ? `${myUrl}?${p}` : `${myUrl}?rgs=0`;
    console.log(path);
    const ms = await API.get("sakurajima", path);
    console.log(ms);
    if (!isLoad) return ms;
    let ums = [];
    for(let i=0; i < ms.length; i++) {
      const m = ms[i];
      console.log('!!!data...' + m.data);
      console.log('!!!memType...' + m.memType);
      console.log(mStatus);
      if (isMNumFilterd && 'NotAssignedYet' == m.data) continue;
      let hit = false;

      if (!(0 == mStatus[0] && 0 == mStatus[1] && 0 == mStatus[2] && 0 == mStatus[3] && 0 == mStatus[4] && 0 == mStatus[5] && 0 == mStatus[6] && 0 == mStatus[7] && 0 == mStatus[8] && 0 == mStatus[9])) {
        switch(m.memType) {
        case "1":
          if (mStatus[0] != 0) hit = true;
	  break;
        case "2":
          if (mStatus[1] != 0) hit = true;
	  break;
        case "4":
          if (mStatus[2] != 0) hit = true;
	  break;
        case "10":
          if (mStatus[3] != 0) hit = true;
	  break;
        case "5":
          if (mStatus[4] != 0) hit = true;
	  break;
        case "7":
          if (mStatus[5] != 0) hit = true;
	  break;
        case "11":
          if (mStatus[6] != 0) hit = true;
	  break;
        case "14":
          if (mStatus[7] != 0) hit = true;
	  break;
        case "15":
          if (mStatus[9] != 0) hit = true;
	  break;
        case "17":
          if (mStatus[8] != 0) hit = true;
	  break;
        default:
	  break;
        }
        console.log('hit = ' + hit);
        if (!hit) continue;
      }
      ums.push(m);
    }
    setMembers(ums);
    return ums;
  }

  function updateMemberStatus(status) {
    console.log(status);
    return API.put("sakurajima", "/memberStatuses", {
	body: status
    });
  }

  const { userProfile, isAdmin } = useAppContext();

  const [fields, messages, handleFieldChange, doValidation] = useFormFields({
    mNumBegin: "",
    mNumEnd: "",
    mName:"",
    mAffiliationName: "",
    mPrefecture: "",
    orderBy: "1",
    ascOrDesc: "1",
    updateStatus: "0",
    subject:"",
    mailBody:"",
  },
  {
    mNumBegin: {n:"", f: (value) => { console.log(value); return '' }},
    mNumEnd: {n:"", f: (value) => { console.log(value); return '' }},
    mName: {n:"", f: (value) => { console.log(value); return '' }},
    mAffiliationName: {n:"", f: (value) => { console.log(value); return '' }},
    mPrefecture: {n:"", f: (value) => { console.log(value); return '' }},
    orderBy: {n:"", f: (value) => { console.log(value); return '' }},
    ascOrDesc: {n:"", f: (value) => { console.log(value); return '' }},
    updateStatus: {n:"", f: (value) => { console.log(value); return '' }},
    subject: {n:"", f: (value) => { console.log(value); return '' }},
    mailBody: {n:"", f: (value) => { console.log(value); return '' }},
  });

  // mStatus checkbox
  const [mStatus, setMStatus] = useState([0,0,0,0,0,0,0,0,0,0]);
  const [checks, setChecks] = useState([]);
  const [selectAll, setSelectAll] = useState(0);

  const [mailTos, setMailTos] = useState([]);

  function handleClear(event) {
    console.log('handleClear...');
    setMStatus([0,0,0,0,0,0,0,0,0,0]);
    fields.mNumBegin = '';
    fields.mNumEnd = '';
    fields.mName = '';
    fields.mAffiliationName = '';
    fields.mPrefecture = '';
    fields.ascOrDesc = "1";
    setPageLimit("50");
    handleSearch(event);
  }

  async function handleDeleteAction(event) {
    console.log('handleDeleteAction...');
    if (!window.confirm('選択した項目を削除します。よろしいですか?')) return;
    let pks = [];
    const mIdx = (currentPage-1) * pageLimit;
    for (let i = 0, idx = mIdx; i < checks.length; i++, idx++) {
      if (checks[i] == 1) {
        console.log('### update: i ' + i + ', idx:' + idx);
        console.log(members[i].familyName);
        pks.push(members[i].pk);
      }
    }
    console.log(pks);
    if (0 === pks.length) { onError('項目を選択して下さい。'); return; }
    try {
      const res = await API.post('sakurajima', '/deleteMembers', {
         body: {pks : pks}
      });
      console.log(res);
      setRefreshCounter(refreshCounter+1);
    } catch (e) {
      onError(e);
    }
  }
    
  function handleMail(event) {
    console.log('handleMail...');
    let ids = [];
    const mIdx = (currentPage-1) * pageLimit;
    for (let i = 0, idx = mIdx; i < checks.length; i++, idx++) {
      if (checks[i] == 1) {
        console.log('### update: i ' + i + ', idx:' + idx);
        ids.push(i);
      }
    }
    console.log(ids);
    if (0 === ids.length) { onError('項目を選択して下さい。'); return; }

    setMailTos(ids);
    setRenderingState('NewMail');
  }

  function backFromMail(event) {
    console.log('handleMail');
    if (event.target.id == "backToList")
      setRenderingState('Main');
    else
      setRenderingState('NewMail');
  }

  async function handleSearch(event) {
    console.log('handleSearch...');
    console.log(fields.orderBy);
    console.log(fields.ascOrDesc);
    setCurrentPage(1);
    try {
      const mc = await loadMembersOnCondition(false, fields.ascOrDesc);
      console.log('seaarch count: ' + mc);
      setTotal(mc);    
      const ms = await loadMembersOnCondition(true, fields.ascOrDesc); 
      console.log('search ms.length:' + ms.length);
      initializeChecks(ms.length);
      const n = parseInt (mc / pageLimit) + ( mc % pageLimit > 0 ? 1 : 0);
      console.log(n);
      console.log(mStatus);
      let ps = [];
      console.log('currentPage: ' + currentPage);
      var pnc = 0; //page num count
      var showLeft = false;
      for(let i=0; i < n; i++) {
        if (n > 9) {
          if (i < currentPage-1) continue;
          if (currentPage > 1 && !showLeft) { ps.push({"label": '<<'}); showLeft = true; }
        }
        pnc++;
        ps.push({"label": i+1});
        if (pnc > 9) {
          ps.push({"label": '>>'});
          break;
        }
      }
      console.log('handleSearch page n=' + n);
      console.log(ps);
      setPages(ps);
    } catch (e) {
      onError(e);
    }
  }

  const getTypeGroup = (type) => {
     return type == 1 || type == 2 || type == 3 ? 1 : (type == 4 || type == 5 || type == 6 ? 2 : 0 );
  };

  async function handleUpdateStatus(event) {
    console.log('handleUpdateStatus -> ' + fields.updateStatus);

    if (0 == fields.updateStatus) {
      onError('種別の変更を指定してください。');
      return;
    }
    console.log(checks);
    console.log(members);
    let ms = members.map((el) => {
      return el.pk;
    });
    console.log(ms);
    let ids = [];
    const mIdx = (currentPage-1) * pageLimit;
    console.log('### update: index ' + mIdx);
    console.log('### update: checks ' + JSON.stringify(checks));
    let group = -1;
    for (let i=0, idx = mIdx; i < checks.length; i++, idx++) {
      if (checks[i] == 1) {
        console.log('### update: i ' + i + ', idx:' + idx);
        console.log('### mx[idx]:  ' + ms[idx]);
        console.log('### messages[idx]:  ' + members[idx].memType);
        group = group == -1 ? getTypeGroup(members[idx].memType) : (group == getTypeGroup(members[idx].memType) ? group : 0) ;
        console.log('### group:  ' + group);
        ids.push(ms[idx]);
      }
    }
    console.log('##### group:  ' + group);
    setMemTypeGroup(group);
    if (0 === ids.length) { onError('項目を選択して下さい。'); return; }

    if (!window.confirm('選択した項目のステータスを変更します。よろしいですか?')) return;

    let params = { ids: ids, memStatus:0, memType:fields.updateStatus };
    
/*
    switch (fields.updateStatus) {
    case "1": // 申込（正会員）
//          params.memStatus = 1;
        params.memType = 1;
      break;
    case "2": // 仮入会（正会員）
//          params.memStatus = 2;
        params.memType = 2;
      break;
    case "3": // 申込（准会員）
//          params.memStatus = 1;
        params.memType = 3;
      break;
    case "4": // 仮入会（准会員）
//          params.memStatus = 2;
        params.memType = 2;
       break;
    case "5": // 審査中（准会員）
        params.memStatus = 3;
        params.memType = 2;
      break;
      default:
    }
*/
    console.log(params);
    try {
//        await updateMemberStatus(params);
//        await loadMembers();
        setRefreshCounter(refreshCounter+1);
        console.log('refreshCounter = ' + refreshCounter);
      } catch (e) {
          onError(e);
      }
  }

  function handleView(e) {
    e.preventDefault();
    const pk = e.target.getAttribute('pk');
    history.push(`/members/${pk}?opt=0&amd=req`);
  }

 function handleEdit(e) {
    e.preventDefault();
    const pk = e.target.getAttribute('pk');
    const mt = e.target.getAttribute('mt');
    //const amd = mt == 7 || mt == 8 || mt == 10 ? 'transfer' : 'req';
    const amd = 'req';
    history.push(`/editMembers/${pk}?opt=0&amd=${amd}`);
 }

 function handleMStatusChange(event) {
    const n = event.target.name;
//    console.log(n.substring('memCommittee'.length));
    const i = parseInt(n.substring('mStatus'.length));
    console.log(i);
    let chs = JSON.parse(JSON.stringify(mStatus));
    chs[i] = event.target.checked ? 1 : 0;
    console.log(chs);
    setMStatus(chs);
  }


  const handlePageChanged = async (e) => {
    console.log('handlePageChanged=>' + e.target.value);
    //handleFieldChange(e);
    setChecksOnPage(members, e.target.value, currentPage);
    setPageLimit(e.target.value);
    const n = parseInt (members.length / pageLimit) + ( members.length % pageLimit > 0 ? 1 : 0);
    console.log(n);
    let ps = [];
    for(let i=0; i < n; i++) ps.push({"label": i+1});
    console.log(ps);
    setPages(ps);
  };

  const pageClickAction2 = (e) => {
    e.preventDefault();
    setSelectAll(0);
    console.log('pageClick');
    console.log(currentPage);
    setRefreshCounter(refreshCounter+1);
    return false;
  }
  const pageClickAction = (e) => {
    e.preventDefault();
    setSelectAll(0);
    console.log('pageClick');
    console.log(currentPage);
    console.log(e.target.href.split('#'));
    const idxLabel = e.target.href.split('#')[1];
    var curp = "1";
    console.log(parseInt(currentPage) + 5);
    if (idxLabel == '>>' || idxLabel== '%3E%3E')
	curp = (parseInt(currentPage) + 5).toString();
    else if (idxLabel == '<<' || idxLabel == '%3C%3C')
	curp = ((parseInt(currentPage) - 5) > 0 ? (parseInt(currentPage) - 5) : 1).toString();
    else 
      curp = idxLabel;
    console.log(typeof curp);
//    const curp = e.target.href.split('#')[1];
    setChecksOnPage(members, pageLimit, curp);
    setCurrentPage(curp);
    setRefreshCounter(refreshCounter+1);
    return false;
  };

  const handleOrderChanged = async (e) => {
    console.log('handleOrderChanged=>' + e.target.value);
    handleFieldChange(e);
/*
    try {
      await loadMembersOnCondition(e.target.value); 
    } catch (e) {
      onError(e);
    }
*/
  };

  const handleItemCheckChanged = (e) => {
    console.log(checks);
    console.log(checks.length);
    console.log(e.target.value);
    let chs = JSON.parse(JSON.stringify(checks));
    if ('selectAll' === e.target.name) {
      console.log('##' + JSON.stringify(chs));
      for(let i=0; checks.length > i; i++) {
        chs[i] = e.target.checked ? 1 : 0;
      }
      console.log('###' + JSON.stringify(chs));
      console.log('## : call setCheck');
      setChecks(chs);
      setSelectAll(e.target.checked ? 1 : 0);
      return;
    }
    console.log('## check value: ' + e.target.value);
    console.log(e.target.value);
    setSelectAll(0);
    chs[e.target.value] = e.target.checked ? 1 : 0;
    console.log('## : call setCheck');
    console.log(chs);
    setChecks(chs);
  };

  const hideSelectItemClass = (type) => {
/*
    if (memType == 1 || memType == 2 || memType == 3) {
      if (type == 4 || type == 5 || type == 6 || type == 7 || type == 8)
        return "hideCkItem";
    }
    if (memType == 4 || memType == 5 || memType == 6) {
      if (type == 1 || type == 2 || type == 3 || type == 7 || type == 8)
        return "hideCkItem";
    }
*/
    return "";
  };

  const createMailHistories = (data) => {
    return API.post('sakurajima', '/mailHistories', {
      body: data
    });
  };

  const sendMail = (data) => {
    return API.post('sakurajima', '/sendBulkMail', {
      body: data
    });
  };

  const handleMailSubmit = async (e) => {
    console.log("handleMailSubmit..." + e.target.id);
    if (e.target.id == 'confirm') {
      if (!fields.subject) { onError("メールのタイトルを入力してください。"); return; }
      if (!fields.mailBody) { onError("メールの本文を入力してください。"); return; }
      setRenderingState('MailConfirm');
    } else {
        if (!window.confirm('配信先一覧宛にメールを送信します。よろしいですか?')) return;
	try {
	    let to = [];
            let dests = [];
            for (const i of mailTos) {
                to.push(members[i].affiliationEmail);
                dests.push({
                  pk:members[i].pk,
                  familyName:members[i].familyName,
                  givenName:members[i].givenName,
                  familyNameKana:members[i].familyNameKana,
                  givenNameKana:members[i].givenNameKana,
                  memberId:members[i].memberId,
                  affiliationDepertment:members[i].affiliationDepertment,
                  affiliationEmail:members[i].affiliationEmail,
                  admissionDate:members[i].admissionDate,
                  updatedAt:members[i].updatedAt,
                });
	    }
            console.log(to);
            console.log(dests);

            let fromName = '【日本臨床スポーツ医学会】';
            fromName = libmime.encodeWord(fromName, 'Q');
            const m = await sendMail({
		subject: fields.subject,
		mailBody: fields.mailBody,
		to: to,
                dests: dests,
                from: fromName + ' <' + config.mail.source + '>',
                enableLog: true
	    });
            fields.subject = "";
            fields.mailBody = "";
            console.log('mail sent complete......');
            setRenderingState('MailSent');
	} catch (e) {
	    onError(e);
	}
    }
  };

  function renderMailComplete() {
    return (
      <AdminMailComplete
        backFromMail={backFromMail}
      />
    );
  }

  function renderMail() {
    return (
      <AdminNewMail
        members={members}
        fields={fields}
        handleFieldChange={handleFieldChange}
        handleMailSubmit={handleMailSubmit}
        backFromMail={backFromMail}
        mailTos={mailTos}
      />
    );
  }

  function renderMailConfirm() {
    return (
      <AdminMailConfirm
        members={members}
        fields={fields}
        handleMailSubmit={handleMailSubmit}
        backFromMail={backFromMail}
        mailTos={mailTos}
      />
    );
  }

  function renderMain() {
    return (
              <section id="contents" className="top">
                <h2>会員申込管理</h2>
                <div id="search">
                  <h3>条件検索</h3>
                  <Table>
                    <tbody>
                      <tr key="memNo">
                        <th>会員番号</th>
                        <td>
                          <Form.Group controlId="mNumBegin" className="inlineFormControl" size="sm">
                            <Form.Control
                              type="text"
                              value={fields.mNumBegin}
                              onChange={handleFieldChange}
                            />
                          </Form.Group>
                          
                          <Form.Group controlId="mNumEnd" className="admHidden inlineFormControl" size="sm">
                            <Form.Control
                              type="text"
                              value={fields.mNumEnd}
                              onChange={handleFieldChange}
                            />
                          </Form.Group>
                        </td>
                      </tr>
                      <tr key="name">
                        <th>氏名</th>
                        <td>
                          <Form.Group controlId="mName" size="sm">
                            <Form.Control
                              type="text"
                              value={fields.mName}
                              onChange={handleFieldChange}
                            />
                          </Form.Group>
                        </td>
                      </tr>
                      <tr key="sAffiliate">
                        <th>所属</th>
                        <td>
                          <Form.Group controlId="mAffiliationName" size="sm">
                            <Form.Control
                              type="text"
                              value={fields.mAffiliationName}
                              onChange={handleFieldChange}
                            />
                          </Form.Group>
                        </td>
                      </tr>
                      <tr key="sMemType">
                        <th>会員種別</th>
                        <td>
                          <Form.Group size="sm">
                            <Form.Check
                              inline
                              label="申込（正会員）"
                              type="checkbox"
                              name="mStatus0"
                              value="1"
                              checked={ 1 == mStatus[0] }
                              onChange={handleMStatusChange}
                            />
                            <Form.Check
                              inline
                              label="仮入会（正会員）"
                              type="checkbox"
                              name="mStatus1"
                              value="1"
                              checked={ 1 == mStatus[1] }
                              onChange={handleMStatusChange}
                            />
<br></br>
                            <Form.Check
                              inline
                              label="申込（准会員）"
                              type="checkbox"
                              name="mStatus2"
                              value="1"
                              checked={ 1 == mStatus[2] }
                              onChange={handleMStatusChange}
                            />
                            <Form.Check
                              inline
                              label="審査中（准会員）"
                              type="checkbox"
                              name="mStatus3"
                              value="1"
                              checked={ 1 == mStatus[3] }
                              onChange={handleMStatusChange}
                            />
                            <Form.Check
                              inline
                              label="仮入会（准会員）"
                              type="checkbox"
                              name="mStatus4"
                              value="1"
                              checked={ 1 == mStatus[4] }
                              onChange={handleMStatusChange}
                            />
<br></br>
                            <Form.Check
                              inline
                              label="申請（准会員から正会員）"
                              type="checkbox"
                              name="mStatus5"
                              value="1"
                              checked={ 1 == mStatus[5] }
                              onChange={handleMStatusChange}
                            />
                            <Form.Check
                              inline
                              label="審査中（准会員から正会員）"
                              type="checkbox"
                              name="mStatus6"
                              value="1"
                              checked={ 1 == mStatus[6] }
                              onChange={handleMStatusChange}
                            />
                          </Form.Group>
                            <Form.Check
                              inline
                              label="申込（学生会員）"
                              type="checkbox"
                              name="mStatus7"
                              value="1"
                              checked={ 1 == mStatus[7] }
                              onChange={handleMStatusChange}
                            />
                            <Form.Check
                              inline
                              label="審査中（学生会員）"
                              type="checkbox"
                              name="mStatus8"
                              value="1"
                              checked={ 1 == mStatus[8] }
                              onChange={handleMStatusChange}
                            />
                            <Form.Check
                              inline
                              label="仮入会（学生会員）"
                              type="checkbox"
                              name="mStatus9"
                              value="1"
                              checked={ 1 == mStatus[9] }
                              onChange={handleMStatusChange}
                            />
                        </td>
                      </tr>
                      <tr key="sPrefectures">
                      <th>都道府県</th>
                        <td>
                          <Form.Group controlId="mPrefecture" size="sm">
                            <Form.Control
                              as="select"
                              custom
                              size="sm"
                              name="mPrefecture"
                              value={fields.mPrefecture}
                              onChange={handleFieldChange}
                            >
<option value="" selected>都道府県選択...</option>
<option value="北海道">北海道</option>
<option value="青森県">青森県</option>
<option value="岩手県">岩手県</option>
<option value="宮城県">宮城県</option>
<option value="秋田県">秋田県</option>
<option value="山形県">山形県</option>
<option value="福島県">福島県</option>
<option value="茨城県">茨城県</option>
<option value="栃木県">栃木県</option>
<option value="群馬県">群馬県</option>
<option value="埼玉県">埼玉県</option>
<option value="千葉県">千葉県</option>
<option value="東京都">東京都</option>
<option value="神奈川県">神奈川県</option>
<option value="新潟県">新潟県</option>
<option value="富山県">富山県</option>
<option value="石川県">石川県</option>
<option value="福井県">福井県</option>
<option value="山梨県">山梨県</option>
<option value="長野県">長野県</option>
<option value="岐阜県">岐阜県</option>
<option value="静岡県">静岡県</option>
<option value="愛知県">愛知県</option>
<option value="三重県">三重県</option>
<option value="滋賀県">滋賀県</option>
<option value="京都府">京都府</option>
<option value="大阪府">大阪府</option>
<option value="兵庫県">兵庫県</option>
<option value="奈良県">奈良県</option>
<option value="和歌山県">和歌山県</option>
<option value="鳥取県">鳥取県</option>
<option value="島根県">島根県</option>
<option value="岡山県">岡山県</option>
<option value="広島県">広島県</option>
<option value="山口県">山口県</option>
<option value="徳島県">徳島県</option>
<option value="香川県">香川県</option>
<option value="愛媛県">愛媛県</option>
<option value="高知県">高知県</option>
<option value="福岡県">福岡県</option>
<option value="佐賀県">佐賀県</option>
<option value="長崎県">長崎県</option>
<option value="熊本県">熊本県</option>
<option value="大分県">大分県</option>
<option value="宮崎県">宮崎県</option>
<option value="鹿児島県">鹿児島県</option>
<option value="沖縄県">沖縄県</option>
                            </Form.Control>
                          </Form.Group>
                        </td>
                      </tr>
                      <tr key="sSort">
                        <th>ソート順</th>
                        <td>
                          <Form.Group className="inlineFormSelect inlineFormControl" controlId="orderBy" size="sm">
                            <Form.Control
                              as="select"
                              custom
                              size="sm"
                              name="orderBy"
                              value={fields.orderBy}
                              onChange={handleFieldChange}
                            >
                              <option value="1">会員番号</option>
                            </Form.Control>
                          </Form.Group>
                          の
                          <Form.Group className="inlineFormSelect inlineFormControl" controlId="ascOrDesc" size="sm">
                            <Form.Control
                              as="select"
                              custom
                              size="sm"
                              name="ascOrDesc"
                              value={fields.ascOrDesc}
                              onChange={handleFieldChange}
                            >
                              <option value="1">降順</option>
                              <option value="2">昇順</option>
                            </Form.Control>
                          </Form.Group>
                        </td>
                      </tr>
                      <tr key="pageLimit">
                        <th>表示件数</th>
                        <td>
                          <Form.Group className="" controlId="pageLimit" size="sm">
                            <Form.Control
                              as="select"
                              custom
                              size="sm"
                              name="pageLimit"
                              value={pageLimit}
                              onChange={handlePageChanged}
                            >
                              <option value="10">10</option>
                              <option value="50">50</option>
                              <option value="100">100</option>
                              <option value="500">500</option>
                            </Form.Control>
                          </Form.Group>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                  <div className="search_btn">
                    <Button id="searchBtn" active size="sm" active onClick={ handleSearch }>検索</Button>
                    <Button id="resetBtn" active size="sm" active onClick={ handleClear }>検索条件クリア</Button>
                  </div>
                </div>
　　　　　　　　　<div id="actionblock">
                 <h3>一括処理</h3>
                 <p>リスト一覧でチェックした情報に対して一括処理を行います。</p>
                 <Form.Group className="inlineFormSelect inlineFormControl" controlId="updateStatus" size="sm">
                   <Form.Control
                     as="select"
                     custom
                     size="sm"
                     name="updateStatus"
                     value={fields.updateStatus}
                     onChange={handleFieldChange}
                   >
                     <option value="0">↓種別の変更</option>
                     <option value="1" disabled={true}>申込（正会員）</option>
                     <option value="2">仮入会（正会員）</option>
                     <option value="3">正会員</option>
                     <option value="3">申込（准会員）</option>
                     <option value="4">仮入会（准会員）</option>
                     <option value="6">准会員</option>
                   </Form.Control>
                 </Form.Group>
                 <Button id="updateStatusBtn" active size="sm" active onClick={ handleUpdateStatus }>ステータス変更</Button>
                 <Button id="sendMailBtn" active size="sm" active onClick={ handleMail }>メール送信</Button>
                 <Button id="deleteBtn" active size="sm" active onClick={ handleDeleteAction }>削除</Button>
               </div>
               <div id="list">
                 <h3>リスト一覧</h3>
                 <p>{ parseInt(pageLimit)*(currentPage-1)+1 } - { parseInt(pageLimit)*(currentPage) }を表示中：ページ{currentPage} (全<b>{ total }</b>件中)</p>
                 <Table>
                   <tbody>
                     <tr key="mbhead">
                       <th>
                            <Form.Check
                              inline
                              type="checkbox"
                              name="selectAll"
                              value="1"
                              checked={ 1 == selectAll }
                              onChange={handleItemCheckChanged}
                            />
                       </th>
                       <th>会員番号</th>
                       <th>氏　名</th>
                       <th>所　属</th>
                       <th>会員種別</th>
                       <th className="tblOperations">処理</th>
                     </tr>
                     <tr>
                     </tr>
          {members.map(({pk,sk,data, familyName, givenName, affiliationName, memStatus, memType}, index) => (
                  <tr key={index}>
                       <td key="chk_{index}">
                            <Form.Check
                              inline
                              type="checkbox"
                              name="memItem"
                              value={index}
                              checked={1 == checks[index]}
                              onChange={handleItemCheckChanged}
                            />
                       </td>
                       <td key="mid_{index}">
                  { 'NotAssignedYet' === data ? '' : data }
                       </td>
                       <td key="name_{index}">
                  {familyName} {givenName}
                       </td>
                       <td key="an_{index}">
                  { affiliationName }
                       </td>
                       <td key="mtyp_{index}">
                  { MemberTypeItemNames[memType] }
                       </td>
                       <td key="btns_{index}">
                  <Button id="viewBtn" pk={ pk } active size="sm" active onClick={ handleView }>詳細</Button>
                  <Button id="editfBtn" pk={ pk } mt={ memType }  active size="sm" active onClick={ handleEdit }>編集</Button>
                       </td>
                  </tr>
                     ))}
                   </tbody>
                 </Table>
                 <div className="pageswitch">
                    <ul>
          { pages.map(({label}, index) => (
		  <li className={(currentPage == label) ? 'active' : ''}><Nav.Link href={ "#" + label} onClick={pageClickAction}>{label}</Nav.Link></li>
	  ))}
                    </ul>
                  </div>
               </div>
              </section>
    );
  }

  return (
    <div className="Admin">
      <h1 id="page_title">管理者用　会員申込管理</h1>
      <div className="container">
        <div id="sub_page">
          <div id="admin" className="top">
              <AdminLeftMenu />
          { renderingState == "Main" ? renderMain() : (renderingState == "NewMail" ? renderMail() : (renderingState == 'MailSent' ? renderMailComplete() :  renderMailConfirm())) }
          </div>
        </div>
      </div>
    </div>
  );
}
